import * as designBuilderApi from '../api/designBuilder';
import updateSignature from './share/updateSignature';

export default (newName, newEmail, newPhone, newExtension) => (dispatch, getState) => {
  const { share } = getState().estimateBuilder;
  const { signature } = share;
  const {
    name = '',
    email = '',
    phone = '',
    extension = '',
  } = signature || {};

  if (newName !== name
      || newEmail !== email
      || newPhone !== phone
      || newExtension !== extension) {
    designBuilderApi.saveDCSignature(newName, newEmail, newPhone, newExtension).then((response) => {
      dispatch(updateSignature(response.data));
    });
  }
};
